import { RouteComponentProps } from "react-router-dom"

export const selectResource = ({
  match
}: RouteComponentProps<{ resourceId: string }>) => {
  const { resourceId } = match.params
  return window.App.getStore("resourceAdmin")
    .action.selectResource(resourceId)
    .loadOfferings(resourceId)
    .promise.then(() => {
      window.App.getStore("authorAdmin").action.loadAuthors()
      window.App.getStore("categoryAdmin").action.loadCategories()
    })
}
